import { PROP, REP_TPL, REP_V2, USR } from "../../../Data/typeDirs";
import { genId } from "../../../utils";

const createReportSchema = {
  _id: genId(),
  name: 'createReportSchema',
  content: [
    {
      name: 'nameContainer',
      type: 'Container',
      displaySettings: { as: 'Container' },
      children: [
        {
          name: 'name',
          type: 'text',
          label: 'Report Name',
        },
        {
          name: 'users',
          source: 'users',
          type: 'multipicker',
          label: 'Assign To Users'
        },
        {
          name: 'template',
          type: 'dropdown',
          source: REP_TPL,
          label: 'Template'
        }
      ],
      
    },
    {
      name: 'reportClientContainer',
      type: 'Container',
      displaySettings: {as: 'Container'},
      children: [
        {
          name: 'clients_v2',
          source: 'clients_v2',
          type: 'dropdown',
          label: 'Client'
        },
        {
          name: PROP,
          source: PROP,
          type: 'dropdown',
          label: 'Property',
          parent: 'clients_v2',
          parentSource: 'clients_v2',
          parentAddress: '_clients_v2'
        }
      ]
    },
    {
      name: 'reportDataContainer',
      type: 'Container',
      displaySettings: {as: 'Container'},
      children: [
        {
          name: 'reportType',
          type: 'dropdown',
          source: 'reportType',
          label: 'Report Type'
        },
        {
          name: 'language_v2',
          source: 'language_v2',
          type: 'dropdown',
          label: 'Language'
        }
      ]
    }
  ]
}

export { createReportSchema }